import React, { createContext, useState, useEffect, ReactElement } from "react";
import { auth, onSnapshotUser } from "../apis/firebase";

import { childrenNodeType } from "../types";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import { i18n } from "../i18n";

import { userRedux } from "../redux";

type AuthContextType = {
  isAuthenticated: boolean;
  isLoading: boolean;
  userInfo: any;
  setUserInfo: any;
};

export const AuthContext = createContext<AuthContextType | null>(null);
import { useAuthState } from "react-firebase-hooks/auth";

let userSnapShotRef = null;

export function AuthProvider({ children }: childrenNodeType): ReactElement {
  const [user, loading] = useAuthState(auth);

  const [userInfo, setUserInfo] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { generalSettings, firebaseInitialized } = useSelector(
    ({ generalSettings, firebase }) => ({
      generalSettings,
      firebaseInitialized: firebase.initialized,
    }),

    shallowEqual
  );

  const dispatcher = useDispatch();

  useEffect(() => {
    if (!!generalSettings.initialized && !loading) {
      (async () => {
        if (
          (!!user && user.isAnonymous) ||
          (!!user && user.emailVerified) ||
          (!!user &&
            !!generalSettings.initialized &&
            !generalSettings?.enforceVerifyEmail)
        ) {
          await updateUserInfo(user);
        } else {
          setIsAuthenticated(false);
          setIsLoading(loading);
        }
      })();
    }
    return () => {
      !!userSnapShotRef && userSnapShotRef();
    };
  }, [user, loading, generalSettings]);

  // To load i18n only after when generalSetting and storageBucket are ready
  useEffect(() => {
    if (!!firebaseInitialized && !!generalSettings) {
      i18n.changeLanguage(generalSettings?.defaultLanguage);
    }
  }, [firebaseInitialized, generalSettings]);

  useEffect(() => {
    if (!userInfo) return;
    dispatcher(userRedux.actions.updateUserInfo({ ...userInfo }));
  }, [userInfo]);

  const updateUserInfo = async (user) => {
    if (!user || !user.uid) return;

    if (!!user && user.isAnonymous) {
      //   setUserInfo({ uid: user.uid, displayName: user.displayName });
      userSnapShotRef = onSnapshotUser(user.uid, (data) => {
        dispatcher(
          userRedux.actions.updateUserInfo({
            uid: user.uid,
            ...data,
          })
        );
        setIsAuthenticated(true);
        setIsLoading(loading);
      });
    } else {
      userSnapShotRef = onSnapshotUser(user.uid, (data) => {
        if (!data) return;
        if (data.disabled) {
          setIsAuthenticated(false);
          return;
        } else {
          setIsAuthenticated(true);
        }

        setIsLoading(loading);

        setUserInfo({ ...data });
      });
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isLoading,
        userInfo,
        setUserInfo,
      }}>
      {children}
    </AuthContext.Provider>
  );
}
